var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/wizard/WizardMainContainer.tsx";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import mediator from 'Utilities/mediator';
import styles from './WizardMainContainer.module.scss';
const WizardMainContainer = ({
  children
}) => {
  const wrapper = useRef(null);
  const [prevScroll, setPrevScroll] = useState(0);
  const scrollTop = useCallback(() => {
    if (wrapper && wrapper.current) {
      wrapper.current.scrollTop = 0;
    }
  }, []);
  const onScrolled = () => {
    if (!wrapper) {
      return;
    }
    const elem = wrapper.current;
    if (!elem) {
      return;
    }
    setPrevScroll(elem.scrollTop);

    // only when scrolling down
    if (elem.scrollTop <= prevScroll) {
      return;
    }
    const range = 10;
    const diff = elem.scrollHeight - elem.scrollTop;
    if (diff >= elem.clientHeight - range && diff <= elem.clientHeight + range) {
      mediator.publish('ui:main-wrapper:scroll-end');
    }
  };
  useEffect(() => {
    const subscription = mediator.subscribe('ui:main-wrapper:scroll-top', scrollTop);
    scrollTop();
    return () => {
      if (subscription) {
        mediator.remove('ui:main-wrapper:scroll-top', subscription.id);
      }
    };
  }, [scrollTop]);
  return /*#__PURE__*/React.createElement("div", {
    id: "wizard-main-container",
    ref: wrapper,
    onScroll: onScrolled,
    className: `${styles.mainContainer}`,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "wizard-container",
    className: "container",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 7
    }
  }, children));
};
export default WizardMainContainer;